module.exports = __webpack_public_path__ + "static/myanalogjournal_web-66502848f32338d5724b108d640a15e0.jpg";